import React from 'react';
import PropTypes from 'prop-types';
import ProductCard from './ProductCard';

import styles from '../css/app.module.css';

const ProductCardGroup = (props) => {
  const renderCard = (key, product) => {
    return (
      <ProductCard
        key={key}
        productId={key}
        onClickActionBtn={props.onClickActionBtn}
        model={product}
        pen={props.pen}
      />
    );
  };

  return (
    <div className={styles['card-group']}>
      <div className={styles['card-group-scrollable']}>
        {Object.keys(props.products).map((key) => renderCard(key, props.products[key]))}
      </div>
    </div>
  );
};

ProductCardGroup.propTypes = {
  products: PropTypes.object.isRequired,
  onClickActionBtn: PropTypes.func.isRequired,
};

export default ProductCardGroup;
